export const baseurl= 'https://usacanmex-back.herokuapp.com/';
export const headers = { 
    'cache-control': 'no-cache',
    'Postman-Token': '780b8b97-3cc6-4a0a-9cf9-1c60bc315086,a76f1bcc-7fad-4192-942f-9311e74bc415',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json' 
  };